import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledTeamAddDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
  }
  
  .InlineForm {
    .Form-fields {
      row-gap: ${props => props.theme.layout('1sp')};
    }
    
    .Form-group-props {
      width: 100%;
      display: flex;
      gap: ${props => props.theme.layout('2sp')};
    }
  }

  ${FormStyles}
  ${ComponentStyles}
`;

StyledTeamAddDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledTeamAddDialog;
